module.exports = __webpack_public_path__ + "img/5_license-car-sp.113deebe.gif";